import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { PhoneNumberHint } from '@/components/Form/PhoneNumberInput/PhoneNumberHint';
import { PhoneNumberInput } from '@/components/Form/PhoneNumberInput/PhoneNumberInput';
import { useFocusAnchor } from '@/utils/useFocusAnchor';

import { formPhoneNumberFieldStyles as sx } from './FormPhoneNumberField.styles';

type Props = {
	label: string;
	id?: string;
	name?: string;
	countryIso: string;
	onCountryIsoChange: (iso: string) => void;
	phoneValue: string;
	onPhoneChange: (value: string) => void;
	errorMessage?: string;
	indicateError?: boolean;
	isDirty?: boolean;
};

export const FormPhoneNumberField = ({
	label,
	id,
	name,
	countryIso,
	onCountryIsoChange,
	phoneValue,
	onPhoneChange,
	errorMessage,
	indicateError,
	isDirty
}: Props) => {
	const { isFocused, anchorEl, onFocus, onBlur, setAnchorEl } =
		useFocusAnchor<HTMLInputElement>();
	const [rowEl, setRowEl] = useState<HTMLDivElement | null>(null);

	return (
		<Box sx={sx.root}>
			<Typography component='label' htmlFor={id} sx={sx.label}>
				{label}
			</Typography>

			<Box sx={sx.fieldWrap}>
				<PhoneNumberInput
					phoneId={id}
					phoneName={name}
					countryIso={countryIso}
					onCountryIsoChange={onCountryIsoChange}
					phoneValue={phoneValue}
					onPhoneChange={onPhoneChange}
					phoneError={!!indicateError}
					phoneIsDirty={isDirty}
					onFocus={onFocus}
					onBlur={onBlur}
					phoneInputRef={setAnchorEl}
					rootRef={setRowEl}
				/>

				<PhoneNumberHint
					visible={isFocused}
					anchorEl={anchorEl}
					boundaryEl={rowEl}
					countryIso={countryIso}
					error={errorMessage}
				/>
			</Box>
		</Box>
	);
};
